import { observer } from "mobx-react-lite";
import { useState } from "react";

import {
  ActionButton,
  applyOpacityToHexColor,
  ContextualMenu,
  FontIcon,
  Stack,
  useTheme
} from "@bps/fluent-ui";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

import { useContextualMenuItem } from "./hooks/useContextualMenuItem.ts";
import { NavBarItem } from "./NavBarItem.tsx";

export const MainMenuItem = observer(
  ({ navLink, index }: { navLink: NavLink; index: number }) => {
    const theme = useTheme();
    const [showMenu, setShowMenu] = useState(false);

    const item = useContextualMenuItem(navLink);

    if (!item) return null;

    const id = `menu-item${index}`;

    if (item.items?.length) {
      return (
        <Stack>
          <ActionButton
            id={id}
            styles={{
              root: {
                height: 38,
                "&:hover": {
                  background: applyOpacityToHexColor(
                    theme.palette.neutralLight,
                    25
                  )
                }
              }
            }}
            onClick={() => {
              setShowMenu(true);
            }}
          >
            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 8 }}
            >
              <span>{item.text}</span>
              <FontIcon
                iconName="ChevronDown"
                styles={{ root: { fontSize: 12 } }}
              />
            </Stack>
          </ActionButton>
          {item.items?.length && showMenu ? (
            <ContextualMenu
              items={item.items}
              target={`#${id}`}
              onDismiss={() => setShowMenu(false)}
            />
          ) : undefined}
        </Stack>
      );
    }

    if (navLink.path) {
      return (
        <NavBarItem
          key={navLink.key || navLink.name}
          text={navLink.name}
          permissions={navLink.path.permissions}
          permissionsOperator={navLink.path.permissionsOperator}
          to={navLink.path.pattern}
        />
      );
    }

    return null;
  }
);
